

/* ===== VELANTIS_SKU_TITLES — pone el SKU como título (grande) de cada producto ===== */

(function(){

  function norm(s){return (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]+/g,' ').trim();}

  var MAP=null, EXACTO=null;
  function buildMap(){
    var m={}, ex={}, amb={};
    (window.VELANTIS_CAT||[]).forEach(function(r){
      if(!r || !r[12]) return;
      ex[String(r[0]).trim()] = r[12];
      var n = norm(r[0]);
      if(m[n] !== undefined && m[n] !== r[12]) amb[n] = 1;
      m[n] = r[12];
    });
    /* Siete nombres existen como perfume y como ambiental: «SANTAL 33» ($589)
       y «Santal 33» ($449), y asi con AVENTUS, BERGAMOTE 22, ERBA PURA,
       LAYTON, THE NOIR 29 y LIME BASIL & MANDARIN. Normalizados caen en la
       misma casilla y ganaba el ultimo, asi que la ficha del perfume acababa
       enseñando el codigo del ambiental.
       Lo ambiguo se retira del atajo. Queda el nombre exacto, que no miente. */
    Object.keys(amb).forEach(function(n){ delete m[n]; });
    EXACTO = ex;
    return m;
  }

  var SEL='.cat-card h3, .card-body h3, .xf-rc .xf-info h4, .pp-simcard h4, #ppName, .vhero-prod';

  function tag(){

    if(!MAP || !Object.keys(MAP).length) MAP=buildMap();

    [].forEach.call(document.querySelectorAll(SEL), function(el){
      /* EL TITULO QUE CAMBIA DE PRODUCTO.
         Antes se salia si el elemento YA tenia data-sku. Pero #ppName no se
         crea de nuevo en cada ficha: la ficha lo reutiliza, asi que al abrir
         el segundo perfume conservaba el codigo del primero. Como el codigo
         se pinta con CSS desde ese atributo, se leia «V033» sobre MEGAMARE.

         Ahora se recuerda PARA QUE TEXTO se etiqueto. Si el texto cambia se
         vuelve a resolver, y si el producto nuevo no tiene codigo se retira
         el viejo en vez de dejarlo mintiendo.

         La marca va en una propiedad del elemento y no en el DOM: este
         bloque corre en cada mutacion de la pagina y comparar dos cadenas
         es mas barato que leer un atributo. */
      var txt = (el.dataset && el.dataset.nombre) || el.textContent; /* la ficha guarda el nombre crudo en data-nombre */
      if (el.__skuTxt === txt) return;
      el.__skuTxt = txt;
      var t = String(txt).trim();
      /* el nombre exacto manda; el normalizado es solo un atajo */
      var sku = (EXACTO && EXACTO[t]) || MAP[norm(t)];
      if (sku) el.setAttribute('data-sku', sku);
      else el.removeAttribute('data-sku');
    });

  }

  function boot(){ tag();

    var mo=new MutationObserver(function(){ tag(); });

    mo.observe(document.body,{childList:true,subtree:true});

  }

  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);

})();

